//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

// The minimum height for the YouTube logo according to their branding guidelines is 20px.
// Since the logo is wider than it is tall, we need to set a size of 27px in order for the
// height to be at least 20px.
// https://www.youtube.com/howyoutubeworks/resources/brand-resources/#logos-icons-and-colors
export const YOUTUBE_ICON_MIN_SIZE = 27;

// YouTube icons must be one of the approved colors according to YouTube's branding guidelines
// https://www.youtube.com/howyoutubeworks/resources/brand-resources/#logos-icons-and-colors
export const YOUTUBE_RED_ICON_COLOR = '#ff0000';
export const YOUTUBE_GRAY_ICON_COLOR = '#282828';

// https://about.instagram.com/brand/gradient
export const INSTAGRAM_ICON_COLOR = '#ff0069';

export const FACEBOOK_ICON_COLOR = '#316ff6';

export const PINTEREST_ICON_COLOR = '#e60023';

export const TWITTER_ICON_COLOR = '#000000';

export const TIKTOK_ICON_COLOR = '#000000';
